import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00800-container" }
const _hoisted_2 = { class: "cmd00800-conditions-form" }
const _hoisted_3 = { class: "row q-gutter-x-sm" }
const _hoisted_4 = {
  class: "col",
  style: {"max-width":"450px"}
}
const _hoisted_5 = {
  id: "sketch-iframe",
  ref: "sketch-iframe",
  "data-toolbars": "reporting",
  title: "marvin js editor",
  src: "../../sketch/editorws.html",
  style: {"overflow":"hidden","width":"100%","height":"100% min-width: 500px","min-height":"350px","border":"1px solid darkgray"}
}
const _hoisted_6 = { class: "col q-gutter-y-sm" }
const _hoisted_7 = { class: "row q-gutter-x-sm" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row q-gutter-x-sm" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row q-gutter-x-sm" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row q-gutter-x-sm" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "row q-gutter-x-sm" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "row q-gutter-x-sm" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "row q-gutter-x-sm" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "row q-gutter-x-sm" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "row q-gutter-x-sm" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "row q-gutter-x-sm" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "q-gutter-x-xs flex justify-end" }
const _hoisted_32 = { class: "full-width row q-gutter-sm" }
const _hoisted_33 = { class: "q-pt-xs" }
const _hoisted_34 = { class: "add-btn-area flex items-center filter-select" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = { style: {"width":"180px","min-width":"180px","max-width":"180px","padding":"2px"} }
const _hoisted_37 = ["href"]

import Loading from 'quasar/src/plugins/Loading.js';;
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import { getMarvin, clearMarvin } from '../../common/marvin-js';
import AtomImage from '../../components/images/AtomImage.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import SearchOpenCloseButton from '../../components/button/SearchOpenCloseButton.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import messages from '../../messages/message.json';

interface Nmol {
  mol_id: string;
  atto_id: string;
  structure: string;
  id_number: string;
  cas_number: string;
  mdl: string;
  name1: string;
  name2: string;
  storage: string;
  hazard_info: string;
  solubility: string;
  target: string;
  memo: string;
  url: string;
  coa: string;
  purity: string;
}
// カラム表示機能
interface VisibleColumn {
  name: string;
  label: string;
}
// 商品ID

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00800',
  setup(__props) {

const delMolId = ref('');
// カラムプルダウン開閉
const open = ref(true);
// 検索結果上限超過フラグ
const resultOverFlg = ref<boolean>(false);
// 検索結果要素
const searchResultElement = ref<HTMLImageElement>();
// 検索可能フラグ
const isContentsExist = ref<boolean>(false);
// 検索エラーダイアログ表示フラグ
const isSearchDisplayFlg = ref<boolean>(false);
// 検索結果フラグ
const searchResult = ref(false);
// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConFlg = ref(false);
// Dialogタイトル
const dialogTitle = ref('');
// Dialog本文
const dialogText = ref(['']);
// Dialog表示レベル
const dialogLevel = ref('');
// 削除確認Dialog表示フラグ
const isDeleteDisplayFlg = ref(false);
// エラーDialog表示フラグ
const isDeleteErrFlg = ref(false);
// テーブルメッセージ
const tableMessage = ref('検索してください。');
// 遷移先のrouter
const router = useRouter();
// 入力データ
const data = ref<Nmol[]>([]);
// 表示カラム
const visibleColumns = ref<Array<string>>([]);
// カラム表示設定の選択肢
const visibleColumnOptions = ref<Array<VisibleColumn>>([]);
// 検索に必要なデータ
const searchCondtions = ref({
  mol_id: '',
  atto_id: '',
  structure: '',
  id_number: '',
  name1: '',
  name2: '',
  purity: '',
  storage: '',
  hazardInfo: '',
  solubility: '',
  target: '',
  memo: '',
  url: '',
  coa: '',
  cas: '',
  mdl: '',
});

// 検索条件（保持用）
const saveSearchCondition = ref({ ...searchCondtions.value });

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'editDelete',
    field: (row: Nmol) => row.mol_id,
    required: true,
  },
  {
    name: ' atto_id',
    label: 'ATTO_ID',
    align: 'left',
    field: (row: Nmol) => row.atto_id,
    sortable: true,
  },
  {
    name: 'structure',
    label: '構造',
    align: 'left',
    field: (row: Nmol) => row.structure,
    classes: 'cmd00800-structure',
    headerClasses: 'cmd00800-structure',
  },
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
    align: 'left',
    field: (row: Nmol) => row.id_number,
    sortable: true,
  },
  {
    name: 'cas_number',
    label: 'CAS No.',
    align: 'left',
    field: (row: Nmol) => row.cas_number,
    sortable: true,
  },
  {
    name: 'mdl',
    label: 'MDL',
    align: 'left',
    field: (row: Nmol) => row.mdl,
    sortable: true,
  },
  {
    name: 'name1',
    label: '化学名１',
    align: 'left',
    field: (row: Nmol) => row.name1,
    sortable: true,
  },
  {
    name: 'name2',
    label: '化学名２',
    align: 'left',
    field: (row: Nmol) => row.name2,
    sortable: true,
  },
  {
    name: 'purity',
    label: 'Purity',
    align: 'left',
    field: (row: Nmol) => row.purity,
    sortable: true,
  },
  {
    name: 'storage',
    label: 'Storage',
    align: 'left',
    field: (row: Nmol) => row.storage,
    sortable: true,
  },
  {
    name: 'hazard_info',
    label: 'Hazard Information',
    align: 'left',
    field: (row: Nmol) => row.hazard_info,
    sortable: true,
  },
  {
    name: 'solubility',
    label: 'Solubility',
    align: 'left',
    field: (row: Nmol) => row.solubility,
    sortable: true,
  },
  {
    name: 'target',
    label: 'Target',
    align: 'left',
    field: (row: Nmol) => row.target,
    sortable: true,
  },
  {
    name: 'memo',
    label: '備考',
    align: 'left',
    field: (row: Nmol) => row.memo,
    sortable: true,
  },
  {
    name: 'url',
    label: 'Supplier_URL',
    align: 'left',
    field: (row: Nmol) => row.url,
    sortable: true,
  },
  {
    name: 'coa',
    label: 'CoA',
    align: 'left',
    field: (row: Nmol) => row.coa,
    sortable: true,
  },
];

/**
 * 商品削除確認ダイアログ表示
 * @param {string} molId 商品ID
 * @param {string} idNumber サプライヤ商品コード
 */
const displayDeleteGoodsDialog = (molId: string, idNumber: string) => {
  delMolId.value = molId;
  dialogLevel.value = 'warning';
  // 削除確認ダイアログのtitleを設定
  dialogTitle.value = '削除確認';
  // 削除確認ダイアログのtextを生成
  dialogText.value = [`サプライヤ商品コード：${idNumber} を削除します。`, `よろしいですか？`];
  // ダイアログ表示判断をtrue(表示)に変更
  isDeleteDisplayFlg.value = true;
  // ダイアログのボタン数判断をfalse(2つ)に
  dialogConFlg.value = false;
};

/**
 * 検索件数上限超過チェック
 * @param {string} searchNumTotal 検索結果件数
 */
const checkOverResult = (searchNumTotal: number) => {
  if (searchNumTotal > Number(messages.ja.validation.search_max_count)) {
    dialogText.value = [
      `先頭から${messages.ja.validation.search_max_count}件までの検索結果を表示しています。`,
      'お探しの化合物が見つからない場合、検索条件を絞り込んで再度検索してください。',
    ];
    dialogTitle.value = '検索結果上限値超過';
    resultOverFlg.value = true;
  }
};

/**
 * 商品検索
 */
const searchGoods = () => {
  isContentsExist.value = false;
  getMarvin().then((structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式の取得に失敗しました。', '画面を開き直して再度お試しください。'];
      isContentsExist.value = false;
    }

    // 検索条件が1つ以上入力されていることをチェック
    Object.entries(searchCondtions.value).forEach(([, value]) => {
      if (value) {
        isContentsExist.value = true;
        isSearchDisplayFlg.value = false;
      }
    });

    // 検索値が入力された場合、検索開始
    if (!isContentsExist.value && structure === undefined) {
      dialogTitle.value = '検索条件入力エラー';
      dialogText.value = ['検索条件を1つ以上入力し、検索してください。'];
      isSearchDisplayFlg.value = true;
    } else {
      // Loading Start
      Loading.show();
      // バックエンド側にデータを連携
      const formData = new FormData();
      formData.append('atto_id', searchCondtions.value.atto_id);
      formData.append('id_number', searchCondtions.value.id_number);
      formData.append('mdl', searchCondtions.value.mdl);
      formData.append('name1', searchCondtions.value.name1);
      formData.append('name2', searchCondtions.value.name2);
      formData.append('purity', searchCondtions.value.purity);
      formData.append('storage', searchCondtions.value.storage);
      formData.append('hazard_info', searchCondtions.value.hazardInfo);
      formData.append('solubility', searchCondtions.value.solubility);
      formData.append('target', searchCondtions.value.target);
      formData.append('structure', structure !== undefined ? structure : '');
      formData.append('memo', searchCondtions.value.memo);
      formData.append('url', searchCondtions.value.url);
      formData.append('cas_number', searchCondtions.value.cas);
      formData.append('coa', searchCondtions.value.coa);
      // 検索実行
      axios
        .post('/cmd008001/search', formData)
        .then((res) => {
          const { common, goodsList, searchNumTotal } = res.data;
          switch (common.status) {
            // 正常終了の場合
            case ResultStatusCode.SUCCESS:
              saveSearchCondition.value = { ...searchCondtions.value };
              checkOverResult(searchNumTotal);
              data.value = goodsList;
              searchResult.value = true;
              tableMessage.value = 'データがありません。';
              break;
            // エラーの場合
            case ResultStatusCode.ERROR:
              switch (common.detail_status) {
                // システムエラーの場合
                case DetailResultStatusCode.STATEMENT_TIMEOUT:
                  dialogTitle.value = '検索時間超過エラー';
                  dialogText.value = [
                    `検索時間が上限に達しました。条件を見直して再検索してください。`,
                  ];
                  isSearchDisplayFlg.value = true;
                  break;
                case DetailResultStatusCode.PARAMETER_ERROR:
                case DetailResultStatusCode.SYSTEM_ERROR:
                  router.push({ name: 'error' });
                  break;
                default:
              }
              break;
            default:
              router.push({ name: 'error' });
          }
        })
        .catch((err) => {
          if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
            // セッションタイムアウトの場合
            router.push({ name: 'login', query: { timeout: 'timeout' } });
          } else {
            // その他エラーの場合
            router.push({ name: 'error' });
          }
        })
        .finally(() => {
          // Loading End
          Loading.hide();
          // スクロール
          setTimeout(() => searchResultElement.value?.scrollIntoView(true), 800);
        });
    }
  });
};

/**
 * 検索条件クリア
 */
const clearSearchCondition = () => {
  clearMarvin().then((err: string) => {
    // MarvinJs読み込み失敗
    if (err === 'error') {
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式のクリアに失敗しました。', '画面を開き直して再度お試しください。'];
      isContentsExist.value = false;
    }
  });
  searchCondtions.value.atto_id = '';
  searchCondtions.value.id_number = '';
  searchCondtions.value.mdl = '';
  searchCondtions.value.name1 = '';
  searchCondtions.value.name2 = '';
  searchCondtions.value.purity = '';
  searchCondtions.value.storage = '';
  searchCondtions.value.hazardInfo = '';
  searchCondtions.value.solubility = '';
  searchCondtions.value.target = '';
  searchCondtions.value.memo = '';
  searchCondtions.value.url = '';
  searchCondtions.value.coa = '';
  searchCondtions.value.cas = '';
  searchCondtions.value.mdl = '';
};

/**
 * 商品情報変更画面に遷移
 * @param {string} molId 商品ID
 */
const editData = (molId: string) => {
  router.push({ name: 'catalogEdit', params: { molId } });
};

/**
 * ダイアログを閉じる
 */
const closeDialog = () => {
  resultOverFlg.value = false;
  setTimeout(() => searchResultElement.value?.scrollIntoView(true), 600);
};

/**
 * 商品削除
 */
const deleteGoods = async () => {
  // Loading Start
  isDeleteErrFlg.value = false;
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('atto_id', saveSearchCondition.value.atto_id);
  formData.append('mol_id', delMolId.value);
  formData.append('id_number', saveSearchCondition.value.id_number);
  formData.append('mdl', saveSearchCondition.value.mdl);
  formData.append('name1', saveSearchCondition.value.name1);
  formData.append('name2', saveSearchCondition.value.name2);
  formData.append('purity', saveSearchCondition.value.purity);
  formData.append('storage', saveSearchCondition.value.storage);
  formData.append('hazard_info', saveSearchCondition.value.hazardInfo);
  formData.append('solubility', saveSearchCondition.value.solubility);
  formData.append('target', saveSearchCondition.value.target);
  formData.append('memo', saveSearchCondition.value.memo);
  formData.append('url', saveSearchCondition.value.url);
  formData.append('cas_number', saveSearchCondition.value.cas);
  formData.append('coa', saveSearchCondition.value.coa);
  await axios
    .post('/cmd008001/delete', formData)
    .then((res) => {
      const { common, goodsList, searchNumTotal } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          dialogLevel.value = 'information';
          // 削除確認ダイアログのtitleを設定
          dialogTitle.value = '削除完了';
          // 削除確認ダイアログのtextを生成
          dialogText.value = [common.message];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConFlg.value = true;
          checkOverResult(searchNumTotal);
          data.value = goodsList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          isDeleteErrFlg.value = true;
          // 削除ダイアログのタイトル
          dialogTitle.value = 'エラー';
          // 削除ダイアログのtext生成
          dialogText.value = [common.message];
          break;
        // システムエラーの場合
        case DetailResultStatusCode.PARAMETER_ERROR:
        case DetailResultStatusCode.SYSTEM_ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// カラム表示設定
for (let i = 0; i < columns.length; i += 1) {
  visibleColumns.value.push(columns[i].name);
  // 編集削除ボタンのカラムは除外
  if (columns[i].name !== 'editDelete') {
    visibleColumnOptions.value.push({
      name: columns[i].name,
      label: columns[i].label,
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[22] || (_cache[22] = [
        _createTextVNode("商品情報一覧")
      ])),
      _: 1
    }),
    _createVNode(_component_q_expansion_item, {
      modelValue: open.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((open).value = $event)),
      "header-style": "display:none"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_card, {
            style: {"background":"var(--q-lightGray)"},
            flat: "",
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "q-gutter-y-lg" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", null, "構造式", -1)),
                      _createElementVNode("iframe", _hoisted_5, null, 512)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", null, "ATTO_ID", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.atto_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchCondtions.value.atto_id) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "12",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", null, "サプライヤ商品コード", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.id_number,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchCondtions.value.id_number) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "200",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", null, "CAS No.", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.cas,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchCondtions.value.cas) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "30",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _cache[27] || (_cache[27] = _createElementVNode("label", null, "MDL", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.mdl,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchCondtions.value.mdl) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "30",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _cache[28] || (_cache[28] = _createElementVNode("label", null, "化学名１", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.name1,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchCondtions.value.name1) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "2000",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", null, "化学名２", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.name2,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchCondtions.value.name2) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "2000",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _cache[30] || (_cache[30] = _createElementVNode("label", null, "Purity", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.purity,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchCondtions.value.purity) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "100",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", null, "Storage", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.storage,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((searchCondtions.value.storage) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "200",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", null, "Hazard Information", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.hazardInfo,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchCondtions.value.hazardInfo) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "200",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", null, "Solubility", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.solubility,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((searchCondtions.value.solubility) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "200",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _cache[34] || (_cache[34] = _createElementVNode("label", null, "Target", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.target,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((searchCondtions.value.target) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "200",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _cache[35] || (_cache[35] = _createElementVNode("label", null, "備考", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.memo,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((searchCondtions.value.memo) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "200",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _cache[36] || (_cache[36] = _createElementVNode("label", null, "Supplier_URL", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.url,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((searchCondtions.value.url) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "300",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _cache[37] || (_cache[37] = _createElementVNode("label", null, "CoA", -1)),
                          _createVNode(_component_q_input, {
                            modelValue: searchCondtions.value.coa,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((searchCondtions.value.coa) = $event)),
                            modelModifiers: { trim: true },
                            outlined: "",
                            dense: "",
                            maxlength: "300",
                            style: {"background":"var(--q-white)"},
                            class: "input-area"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_q_btn, {
                      color: "primary",
                      style: {"width":"150px"},
                      label: "検索",
                      icon: "mdi-magnify",
                      onClick: searchGoods
                    }),
                    _createVNode(_component_q_btn, {
                      outline: "",
                      style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                      icon: "mdi-eraser",
                      label: "クリア",
                      onClick: clearSearchCondition
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(SearchOpenCloseButton, {
      display: searchResult.value,
      open: open.value,
      style: {"margin-bottom":"20px"},
      onOpen: _cache[15] || (_cache[15] = ($event: any) => (open.value = $event))
    }, null, 8, ["display", "open"]),
    _createElementVNode("div", {
      ref_key: "searchResultElement",
      ref: searchResultElement,
      class: "cmd00800-result-table"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button ' + (data.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: data.value,
          columns: columns,
          "row-key": "index",
          flat: "",
          dense: "",
          "visible-columns": visibleColumns.value,
          separator: "cell",
          "no-data-label": tableMessage.value,
          "rows-per-page-options": [10, 20, 50],
          "rows-per-page-label": "件表示",
          "rows-per-page": "20",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_33, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_q_select, {
                modelValue: visibleColumns.value,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((visibleColumns).value = $event)),
                multiple: "",
                outlined: "",
                dense: "",
                "options-dense": "",
                "display-value": "カラム表示設定",
                "emit-value": "",
                "map-options": "",
                options: visibleColumnOptions.value,
                "option-value": "name",
                color: "primary",
                class: "column-disp"
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          "header-cell-editDelete": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area delete-btn-exists" })
          ]),
          "body-cell-editDelete": _withCtx((cell) => [
            _createVNode(_component_q_td, { class: "table-btn-area delete-btn-exists" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_q_btn, {
                    icon: "mdi-pencil",
                    label: "編集",
                    color: "primary",
                    onClick: ($event: any) => (editData(cell.row.mol_id))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_q_btn, {
                    icon: "mdi-close",
                    label: "削除",
                    class: "deletebtn",
                    color: "primary",
                    outline: "",
                    style: {"color":"var(--q-delete)"},
                    onClick: ($event: any) => (displayDeleteGoodsDialog(cell.row.mol_id, cell.row.id_number))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell-structure": _withCtx((structure) => [
            _createVNode(_component_q_td, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(AtomImage, {
                    exatoms: structure.row.structure
                  }, null, 8, ["exatoms"])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell-url": _withCtx((body) => [
            _createVNode(_component_q_td, {
              props: body,
              class: _normalizeClass(body.row.del_flg === '1' ? 'deleted' : '')
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: body.value,
                  target: "_blank"
                }, _toDisplayString(body.value), 9, _hoisted_37)
              ]),
              _: 2
            }, 1032, ["props", "class"])
          ]),
          _: 1
        }, 8, ["rows", "visible-columns", "no-data-label", "pagination-label"])
      ], 2)
    ], 512),
    _createVNode(AlertDialog, {
      display: isDeleteDisplayFlg.value,
      level: dialogLevel.value,
      confirmation: dialogConFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onConfirm: deleteGoods,
      onComplete: _cache[17] || (_cache[17] = ($event: any) => (isDeleteDisplayFlg.value = false)),
      onClose: _cache[18] || (_cache[18] = ($event: any) => (isDeleteDisplayFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: resultOverFlg.value,
      level: "warning",
      confirmation: "",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: closeDialog
    }, null, 8, ["display", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isSearchDisplayFlg.value,
      level: "error",
      confirmation: "",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[19] || (_cache[19] = ($event: any) => (isSearchDisplayFlg.value = false))
    }, null, 8, ["display", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isDeleteErrFlg.value,
      level: "error",
      confirmation: "",
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[20] || (_cache[20] = ($event: any) => (isDeleteErrFlg.value = false)),
      onClose: _cache[21] || (_cache[21] = ($event: any) => (isDeleteErrFlg.value = false))
    }, null, 8, ["display", "title", "text"])
  ]))
}
}

})